import type { CampaignPageAnalyticsEvent } from '../events'
import type { CampaignDetailsSlugType } from '@twlvxtwlv/types'

export function getCampaignPageAnalyticsEventForSlug(
  navigationSlug: CampaignDetailsSlugType,
  campaignSlug: string | undefined,
  campaignId: string | undefined,
  artistName: string | undefined,
  artistId: string | undefined,
  nftName: string | undefined,
  nftId: string | undefined
): CampaignPageAnalyticsEvent | null {
  let event: CampaignPageAnalyticsEvent | null = null

  if (navigationSlug.startsWith('token-')) {
    event = {
      eventName: 'campaign-page-nft-section-viewed',
      campaignSlug: campaignSlug ?? 'MISSING_VALUE',
      campaignId: campaignId ?? 'MISSING_VALUE',
      artistName: artistName ?? 'MISSING_VALUE',
      artistId: artistId ?? 'MISSING_VALUE',
      nftName: nftName ?? 'MISSING_VALUE',
      nftId: nftId ?? 'MISSING_VALUE',
    }
    return event
  }
  switch (navigationSlug) {
    case 'about':
      event = {
        eventName: 'campaign-page-campaign-contents-section-viewed',
        campaignSlug: campaignSlug ?? 'MISSING_VALUE',
        campaignId: campaignId ?? 'MISSING_VALUE',
        artistName: artistName ?? 'MISSING_VALUE',
        artistId: artistId ?? 'MISSING_VALUE',
      }
      break
    case 'roadmap':
      event = {
        eventName: 'campaign-page-roadmap-section-viewed',
        campaignSlug: campaignSlug ?? 'MISSING_VALUE',
        campaignId: campaignId ?? 'MISSING_VALUE',
        artistName: artistName ?? 'MISSING_VALUE',
        artistId: artistId ?? 'MISSING_VALUE',
      }
      break
  }

  return event
}
